/**
 * Laufzeitkonfiguration aus `/config.json` (ADR-0027, identitaeten.md §8): Das Bündel enthält keine stackabhängigen
 * Werte; ein Build bedient Test- und App-Stack. Ohne Netz gilt die zuletzt geladene (öffentliche) Konfiguration.
 */
export interface Laufzeitkonfiguration {
  firebase: { apiKey: string; projectId: string; appId: string; messagingSenderId: string; firestoreDatabaseId: string };
  tenantId: string;
  vapidKey: string | null;
  origin: string;
  plattform: Record<string, number>;
  /** nur an der alten Adresse im Umzugsmodus: Origin der neuen Adresse (identitaeten.md §8, §11) */
  umzug?: { ziel: string } | null;
}

/**
 * Im Umzugsmodus führt jeder Pfad außer dem Start der App zur neuen Adresse, mit Suche und Fragment (z. B. Einladungstoken):
 * Der Service Worker liefert die App-Shell für jede Navigation selbst, die Weiterleitung des Dienstes greift dann nicht.
 */
export function umzugsweiterleitung(k: Laufzeitkonfiguration, ort: Pick<Location, "pathname" | "search" | "hash">): string | null {
  const ziel = k.umzug?.ziel;
  if (!ziel || ort.pathname === "/" || ort.pathname === "/index.html") return null;
  return `${ziel}${ort.pathname}${ort.search}${ort.hash}`;
}

const SCHLUESSEL = "dj-konfiguration";

export async function konfigurationLaden(): Promise<Laufzeitkonfiguration> {
  try {
    const r = await fetch("/config.json", { cache: "no-store" });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const k = (await r.json()) as Laufzeitkonfiguration;
    localStorage.setItem(SCHLUESSEL, JSON.stringify(k));
    return k;
  } catch (e) {
    const gemerkt = localStorage.getItem(SCHLUESSEL);
    if (gemerkt) return JSON.parse(gemerkt) as Laufzeitkonfiguration;
    throw e;
  }
}
